import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Tip } from './elements/Tip'

export const ThemeContainer = styled.div`
  position: relative;
  height: 100%;
`

export const Container = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  display: flex;
  width: 100%;
  height: 332px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;

  ${Media.Phone`
    flex-direction: column-reverse; 
    height: 336px;
  `};
`

export const TipIcon = styled(Tip)<{ $tipPosition: number; $tipBackgroundColor?: string }>`
  position: absolute;
  left: -13px;
  color: ${({ theme, $tipBackgroundColor }) => $tipBackgroundColor || theme.background};
  top: ${({ $tipPosition }) => $tipPosition}px;

  ${Media.Laptop` left: 50%; top: -25px; transform: rotate(90deg); `}
`

export const WidgetContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;

  ${Media.Phone` 
    flex-direction: column-reverse; 
  `};
`

export const WidgetBox = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  position: relative;
`

export const WidgetImage = styled.img`
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  align-self: center;
  vertical-align: middle;
  display: flex;
  margin: auto;

  ${Media.Phone` 
    max-height: 160px; 
    height: 100%;
    object-fit: cover; 
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  `};
`

export const ActionButton = styled.button`
  background: ${Colors.White};
  color: ${Colors.Neutral90};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px;
  ${Typography.Body}
  ${FontWeights.Regular}
  border: 1px solid ${Colors.Neutral15};
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
`
